<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>{{ data.title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container" [formGroup]="form">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Durée maximale du workflow</mat-label>
                    <app-time-duration-input formControlName="maxDuration" autocomplete="off" />
                    @if (form.get('maxDuration').hasError('required')) {
                        <mat-error>Le champ 'Durée maximale du workflow' est obligatoire.</mat-error>
                    }
                    @if (form.get('maxDuration').hasError('format')) {
                        <mat-error>La valeur du champ 'Durée maximale du workflow' ne respecte pas le format.</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="maxDurationTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="save()" [disabled]="form.invalid">Appliquer</button>
    </mat-card-actions>
</mat-card>
